import getPageBindings from './page-bindings';

const getPageBindingById = (rootState, pageId, bindingId) =>
  getPageBindings(rootState, pageId).find((v) => v.id === bindingId) || null;

export default getPageBindingById;
